import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import ProductPrice from '@repo/ui/src/components/Product/Price';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ProductVariation } from '@typings/product';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';
import Product from '@models/product';
import { useIsMobile } from '@repo/ui/src/utils/useMediaQuery';
import { useVipAccess } from '@hooks/customer';

interface Props {
  variation: ProductVariation | Product;
}

const isProductVariation = (item: ProductVariation | Product): item is ProductVariation =>
  !!(item as ProductVariation).attributesMap;

const GrillCardInterior = ({ variation }: Props) => {
  const { t } = useTranslation();
  const { vip } = useVipAccess();

  const isMobile = useIsMobile();

  const cookingSpace = isProductVariation(variation)
    ? variation?.grillSize
    : variation?.productData?.cookingSpace?.tier?.reduce(
        (total, tier) => tier.width * tier.depth + total,
        0,
      ) || null;

  const imgUrl = buildImageSrc(undefined, 98, 1, 1, variation.mainImageUrl);

  return (
    <div className="grid grid-cols-[auto_1fr] justify-center gap-4 sm:gap-5 h-full items-start md:items-center p-5">
      <div className="grid items-center h-full">
        <LazyLoadImage imgComponent={<img src={imgUrl} alt="" />} />
      </div>
      <div className="grid grid-cols-[1fr_auto] sm:gap-5 justify-center items-center h-full">
        <div className="self-center">
          <h3 className="tra-text-web-heading-6 !text-3xl">{variation.title}</h3>
          {cookingSpace && (
            <p className="tra-text-web-body-l pt-2">
              {`${cookingSpace} ${t('productDetailPageContent.cookingAreaText', undefined, {
                default: 'cooking area',
              })}`}
            </p>
          )}
          {isMobile && (
            <ProductPrice
              className="pt-2 !text-2xl"
              product={variation}
              variant="h7"
              component="p"
              align="left"
              vip={vip}
            />
          )}
        </div>
        {!isMobile && (
          <ProductPrice
            className="sm:items-center pt-2 md:pt-0 sm:flex-col sm:justify-around [&_del]:lg:pt-0 !text-2xl"
            product={variation}
            variant="h7"
            component="p"
            align="left"
            vip={vip}
          />
        )}
      </div>
    </div>
  );
};

export default GrillCardInterior;
